

  <div *ngIf="url != 'dark' || url == '' || url === null || url === undefined">
    <app-navbar (clickSide)="checkSideNav($event)"></app-navbar>
  </div>
  <div *ngIf="sidebar">
    <app-sidebar ></app-sidebar>
  </div>
  <div *ngIf="url == 'dark'">
    <app-navbar-dark></app-navbar-dark>
  </div>
  <router-outlet></router-outlet>
